const config = {
    backend_url: 'https://genplan.m2o2.ru/',
    // backend_url: 'http://genplan.local/'
}
export default config
